import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = logged out

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(null); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("token");
      setUser(null);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    // fetch full profile with subscription_active flag
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("token", data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    // clear notes/papers cache so a different user doesn't see stale content
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const k = localStorage.key(i);
        if (k && k.startsWith("cache:")) localStorage.removeItem(k);
      }
    } catch {}
    setUser(null);
  };

  const refreshUser = async () => {
    const me = await api.get("/auth/me");
    setUser(me.data);
  };

  return (
    <AuthCtx.Provider value={{ user, login, signup, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
